module.exports = __webpack_public_path__ + "static/media/heading.300a7fc8.svg";